// eslint-disable-next-line import/prefer-default-export
export function round(value, precision) {
  const roundedValue = Math.round(value / precision) * precision;
  return roundedValue < precision ? precision : roundedValue;
}
